/**
 * Public SEO solution pages — one URL per ICP job (hub + spoke).
 * CTA deep-links into `/agentic` with the matching intent.
 */

import type { AgenticIntentId } from './agenticIntents';
import { AGENTIC_INTENTS, buildAgenticPath } from './agenticIntents';

export type SolutionSlug =
  | 'hld'
  | 'estimation'
  | 'rfp'
  | 'migration'
  | 'compare'
  | 'ai-cost'
  | 'board-pack'
  | 'optimize';

export interface SolutionPageConfig {
  slug: SolutionSlug;
  intentId: AgenticIntentId;
}

export const SOLUTION_PAGES: SolutionPageConfig[] = [
  { slug: 'board-pack', intentId: 'full' },
  { slug: 'hld', intentId: 'hld' },
  { slug: 'estimation', intentId: 'estimate' },
  { slug: 'rfp', intentId: 'rfp' },
  { slug: 'compare', intentId: 'compare' },
  { slug: 'migration', intentId: 'migration' },
  { slug: 'ai-cost', intentId: 'ai_cost' },
  { slug: 'optimize', intentId: 'optimize' },
];

const slugSet = new Set(SOLUTION_PAGES.map((p) => p.slug));

export function isSolutionSlug(value: string): value is SolutionSlug {
  return slugSet.has(value as SolutionSlug);
}

export function getSolutionConfig(slug: SolutionSlug): SolutionPageConfig | undefined {
  return SOLUTION_PAGES.find((p) => p.slug === slug);
}

export function getSolutionCtaPath(slug: SolutionSlug): string {
  const cfg = getSolutionConfig(slug);
  if (!cfg) return '/start';
  const def = AGENTIC_INTENTS.find((i) => i.id === cfg.intentId);
  if (!def) return '/start';
  return buildAgenticPath(def);
}

export const SOLUTION_SITEMAP_PATHS = [
  '/solutions',
  ...SOLUTION_PAGES.map((p) => `/solutions/${p.slug}`),
];
